export const deviationCategory = [
  {
    value: "1",
    label: "Plan was approved and deviation beyond permissible limit Upto extent of 10%",
    name: "Plan was approved and deviation beyond permissible limit Upto extent of 10%",
  },
  {
    value: "2",
    label: "Plan was not approved and construction carried out without deviation",
    name: "Plan was not approved and construction carried out without deviation",
  },
  {
    value: "3",
    label: "Plan was not approved and deviation beyond permissible limit Upto the extent of 10%",
    name: "Plan was not approved and deviation beyond permissible limit Upto the extent of 10%",
  },
  {
    value: "4",
    label: "Building constructed on under size plot to the extent of 10% less than the permissible plot size",
    name: "Building constructed on under size plot to the extent of 10% less than the permissible plot size",
  },
];

export const nameSuffix = [
  {
    value: "Mr.",
    label: "Mr.",
  },
  {
    value: "Mrs.",
    label: "Mrs.",
  },
  {
    value: "Miss.",
    label: "Miss.",
  },
];

export const relationSuffix = [
  {
    value: "S/O",
    label: "S/O",
  },
  {
    value: "D/O",
    label: "D/O",
  },
  {
    value: "W/O",
    label: "W/O",
  },
];

export const departmentList = [
  {
    value: "AVP",
    label: "UPAVP",
    name: "avp",
  },
  {
    value: "DA",
    label: "DA",
    name: "da",
  },
];
export const scrutinyList = [
  {
    value: "PDF",
    label: "Via PDF",
    name: "pdf",
  },
  {
    value: "EDCR",
    label: "Via EDCR Scrutiny",
    name: "edcr",
  },
];

export const paymentMethodList = [
  {
    value: "NEFT",
    label: "NEFT",
    name: "NEFT",
  },
  {
    value: "RTGS",
    label: "RTGS",
    name: "RTGS",
  },
  {
    value: "UPI",
    label: "UPI",
    name: "UPI",
  },
  {
    value: "Challan",
    label: "Challan",
    name: "Challan",
  },
];

export const propertyTypeList = [
  {
    value: "Govt.",
    label: "Govt.",
    name: "Govt.",
  },
  {
    value: "Private",
    label: "Private",
    name: "Private",
  },
  {
    value: "Himuda",
    label: "Himuda",
    name: "Himuda",
  },
];

export const qualificationTypeList = [
  {
    value: "B.Arch",
    label: "B.Arch",
    name: "B.Arch",
    type: "Architect",
  },
  {
    value: "M.Arch",
    label: "M.Arch",
    name: "M.Arch",
    type: "Architect",
  },
  {
    value: "B.E",
    label: "B.E",
    name: "B.E",
    type: "Graduate Civil Engineer",
  },
  {
    value: "M.E",
    label: "M.E",
    name: "M.E",
    type: "Graduate Civil Engineer",
  },
  {
    value: "B.Tech",
    label: "B.Tech",
    name: "B.Tech",
    type: "Graduate Civil Engineer",
  },
  {
    value: "M.Tech",
    label: "M.Tech",
    name: "M.Tech",
    type: "Graduate Civil Engineer",
  },
  {
    value: "Diploma in Civil Engineering",
    label: "Diploma in Civil Engineering",
    name: "Diploma in Civil Engineering",
    type: "Supervisor",
  },
  {
    value: "Architectural Assistantship",
    label: "Architectural Assistantship",
    name: "Architectural Assistantship",
    type: "Supervisor",
  },
  {
    value: "B.Plan",
    label: "B.Plan",
    name: "B.Plan",
    type: "Town Planner",
  },
  {
    value: "M.Plan",
    label: "M.Plan",
    name: "M.Plan",
    type: "Town Planner",
  },
  {
    value: "B.E",
    label: "B.E",
    name: "B.E",
    type: "Structural Engineer",
  },
  {
    value: "M.E",
    label: "M.E",
    name: "M.E",
    type: "Structural Engineer",
  },
  {
    value: "B.Tech",
    label: "B.Tech",
    name: "B.Tech",
    type: "Structural Engineer",
  },
  {
    value: "M.Tech",
    label: "M.Tech",
    name: "M.Tech",
    type: "Structural Engineer",
  },
  {
    value: "B.Arch",
    label: "B.Arch",
    name: "B.Arch",
    type: "Landscape Architect",
  },
  {
    value: "B.Arch",
    label: "B.Arch",
    name: "B.Arch",
    type: "Urban Designer",
  },
  {
    value: "B.Plan",
    label: "B.Plan",
    name: "B.Plan",
    type: "Urban Designer",
  },
  {
    value: "M.Plan",
    label: "M.Plan",
    name: "M.Plan",
    type: "Urban Designer",
  },
  {
    value: "B.E",
    label: "B.E",
    name: "B.E",
    type: "Engineers for Utility Services",
  },
  {
    value: "M.E",
    label: "M.E",
    name: "M.E",
    type: "Engineers for Utility Services",
  },
];

export const proposalSubmittedFor = [
  {
    value: "ApprovalOfMap",
    label: "Approval of map",
    name: "Approval of map",
  },
  {
    value: "ChangeOfExistingBuildingUse",
    label: "Change of Existing building use",
    name: "Change of Existing building use",
  },
  {
    value: "RevisedProposalOfApprovedMap",
    label: "Revised proposal of approved map",
    name: "Revised proposal of approved map",
  },
  {
    value: "ReconstructionOnOldLine",
    label: "Reconstruction on old line",
    name: "Reconstruction on old line",
  },
  {
    value: "AlterationAdditionOfExistingBuilding",
    label: "Alteration/Addition of Existing building",
    name: "Alteration/Addition of Existing building",
  },
];
export const classList = [
  {
    value: "A",
    label: "A",
    name: "A",
  },
  {
    value: "B",
    label: "B",
    name: "B",
  },
  {
    value: "C",
    label: "C",
    name: "C",
  },
];
export const appliedLandUseList = [
  {
    value: "commercial",
    label: "Commercial",
    name: "Commercial",
  },
];
export const propertyType = [
  {
    value: "Plot",
    label: "Plot",
    name: "Plot",
  },
  {
    value: "House",
    label: "House",
    name: "House",
  },
  {
    value: "Flat",
    label: "Flat",
    name: "Flat",
  },
  {
    value: "City",
    label: "City",
    name: "City",
  },
];
export const projectTypeOptions = [
  {
    value: "Building Permission-Low Risk",
    label: "Building Permission-Low Risk",
    name: "Building Permission-Low Risk",
  },
  {
    value: "Building Permission-High Risk/Group Housing",
    label: "Building Permission-High Risk/Group Housing",
    name: "Building Permission-High Risk/Group Housing",
  },
  {
    value: "Layout Development",
    label: "Layout Development",
    name: "Layout Development",
  },
  {
    value: "Other",
    label: "Other",
    name: "Other",
  },
];
export const completionProjectTypes = [
  {
    value: "Medium Risk (Residential Case)",
    label: "Medium Risk (Residential Case)",
    name: "Medium Risk (Residential Case)",
  },
  {
    value: "High Risk (Other than residential case)",
    label: "High Risk (Other than residential case)",
    name: "High Risk (Other than residential case)",
  },
];
export const ConstructionTypeOptions = [
  {
    value: "Built-up Area",
    label: "Built-up Area",
    name: "Built-up Area",
  },
  {
    value: "Non-Built-up Area",
    label: "Non-Built-up Area",
    name: "Non-Built-up Area",
  },
];

export const governmentBuildingOptions = [
  {
    value: "Government Building",
    label: "Government Building",
    name: "Government Building",
  },
];

export const propertyTypeListUP = [
  {
    value: "Plot",
    label: "Plot",
    name: "Plot",
  },
  {
    value: "House",
    label: "House",
    name: "House",
  },
  {
    value: "Flat",
    label: "Flat",
    name: "Flat",
  },
];
export const appliedByList = [
  {
    value: "citizen",
    label: "Citizen",
    name: "Citizen",
  },
  {
    value: "lokMiterKender",
    label: "Lok miter kender",
    name: "Lok miter kender",
  },
];
export const vacantOrBuilt = [
  {
    value: "Vacant",
    label: "Vacant",
    name: "Vacant",
  },
  {
    value: "Built",
    label: "Built",
    name: "Built",
  },
];

export const guaranteeList = [
  {
    value: "Bank Gaurantee",
    label: "Bank Gaurantee",
    name: "Bank Gaurantee",
  },
  {
    value: "Land Mortgaged",
    label: "Land Mortgaged",
    name: "Land Mortgaged",
  },
];
export const specialProjectList = [
  {
    value: "Transit Oriented Development (TOD)",
    label: "Transit Oriented Development (TOD)",
    name: "Transit Oriented Development (TOD)",
  },
  {
    value: "Government Building",
    label: "Government Building",
    name: "Government Building",
  },
  {
    value: "Type design",
    label: "Type design",
    name: "Type design",
  },
  {
    value: "Mixed Use Along 18/24M Wide Road",
    label: "Mixed Use Along 18/24M Wide Road",
    name: "Mixed Use Along 18/24M Wide Road",
  },
  {
    value: "Pradhan Mantri Awas Yojna (PMAY)",
    label: "Pradhan Mantri Awas Yojna (PMAY)",
    name: "Pradhan Mantri Awas Yojna (PMAY)",
  },
];
export const yesOrNo = [
  {
    value: "yes",
    label: "Yes",
    name: "Yes",
  },
  {
    value: "no",
    label: "No",
    name: "No",
  },
];
export const buildingInternalChanges = [
  {
    value: "Under building byelaws",
    label: "Under building byelaws",
    name: "Under building byelaws",
  },
  {
    value: "If contrary to the byelaws It has been extinguished",
    label: "If contrary to the byelaws It has been extinguished",
    name: "If contrary to the byelaws It has been extinguished",
  },
];
export const fullyPartial = [
  {
    value: "Fully",
    label: "Fully",
    name: "Fully",
  },
  {
    value: "Partially",
    label: "Partially",
    name: "Partially",
  },
];

export const additionalFar = [
  {
    value: "3%",
    label: "3%",
    name: "3%",
  },
  {
    value: "5%",
    label: "5%",
    name: "5%",
  },
  {
    value: "7%",
    label: "7%",
    name: "7%",
  },
];
export const plotsDropdowns = [
  { code: "Plot No.", name: "Plot No." },
  { code: "Khasra No.", name: "Khasra No." },
  { code: "Araji No.", name: "Araji No." },
];
export const ownerOrLtp = [
  {
    value: "OWNER",
    label: "OWNER",
    name: "OWNER",
  },
  {
    value: "LTP",
    label: "LTP",
    name: "LTP",
  },
];

export const approvedOrShortfall = [
  {
    value: "approved",
    label: "Approved",
    name: "Approved",
  },
  {
    value: "shortfall",
    label: "Shortfall",
    name: "Shortfall",
  },
];

export const siteInspRecommendation = [
  {
    value: "Rejection",
    label: "Rejection",
    name: "Rejection",
  },
  {
    value: "Approval",
    label: "Approval",
    name: "Approval",
  },
  {
    value: "Shortfall",
    label: "Shortfall",
    name: "Shortfall",
  },
];

export const innerInspRecommendation = [
  {
    value: "Map is not as per Building Byelwas",
    label: "Map is not as per Building Byelwas",
    name: "Map is not as per Building Byelwas",
  },
  {
    value: "Proposed Map is against land use report",
    label: "Proposed Map is against land use report",
    name: "Proposed Map is against land use report",
  },
  {
    value: "Ground coverage & FAR is not as per Building Byelaws",
    label: "Ground coverage & FAR is not as per Building Byelaws",
    name: "Ground coverage & FAR is not as per Building Byelaws",
  },
  {
    value: "Set back & Parking is not as per Building Byelaws",
    label: "Set back & Parking is not as per Building Byelaws",
    name: "Set back & Parking is not as per Building Byelaws",
  },
  {
    value: "Key Plan & Google Co-ordinates of Proposed site is not provided",
    label: "Key Plan & Google Co-ordinates of Proposed site is not provided",
    name: "Key Plan & Google Co-ordinates of Proposed site is not provided",
  },
  {
    value: "Plot mortgaged in favor of LDA",
    label: "Plot mortgaged in favor of LDA",
    name: "Plot mortgaged in favor of LDA",
  },
  {
    value: "Elevation, Section & Plot Boundaries is not correct",
    label: "Elevation, Section & Plot Boundaries is not correct",
    name: "Elevation, Section & Plot Boundaries is not correct",
  },
  {
    value: "Map is not as per control design",
    label: "Map is not as per control design",
    name: "Map is not as per control design",
  },
  {
    value: "Ground coverage & FAR is not as per Deed",
    label: "Ground coverage & FAR is not as per Deed",
    name: "Ground coverage & FAR is not as per Deed",
  },
  {
    value: "Setback is not as marked in approved Layout",
    label: "Setback is not as marked in approved Layout",
    name: "Setback is not as marked in approved Layout",
  },
];

export const recommendation = [
  {
    value: "Not accepted",
    label: "Not accepted",
    name: "Not accepted",
  },
  {
    value: "Accepted",
    label: "Accepted",
    name: "Accepted",
  },
];
export const remarks = [
  // {
  //   value: "Document accepted for map approval",
  //   label: "Document accepted for map approval",
  //   name: "Document accepted for map approval",
  // },
  {
    value: "Plz upload full documents in chronological order",
    label: "Plz upload full documents in chronological order",
    name: "Plz upload full documents in chronological order",
  },
  {
    value: "Not accepted plz upload relevant document as per guidelines",
    label: "Not accepted plz upload relevant document as per guidelines",
    name: "Not accepted plz upload relevant document as per guidelines",
  },
  {
    value: "Not readable please upload clear scan image",
    label: "Not readable please upload clear scan image",
    name: "Not readable please upload clear scan image",
  },

  {
    value: "Upload a valid document",
    label: "Upload a valid document",
    name: "Upload a valid document",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];

export const ownerOrApplicant = [
  {
    value: "owner",
    label: "Owner",
    name: "Owner",
  },
  {
    value: "Applicant",
    label: "Applicant",
    name: "Applicant",
  },
];
export const yesNoNA2 = [
  {
    value: "yes",
    label: "Yes",
    name: "Yes",
  },
  {
    value: "no",
    label: "No",
    name: "No",
  },
  {
    value: "N/A",
    label: "N/A",
    name: "N/A",
  },
];
export const yesNoNA = [
  {
    value: "yes",
    label: "Yet to Verify",
    name: "Yes",
  },
  {
    value: "",
    label: "No",
    name: "No",
  },
  {
    value: "N/A",
    label: "N/A",
    name: "N/A",
  },
];
export const septicTank = [
  {
    value: "Connectivity to the septic tank",
    label: "Connectivity to the septic tank",
    name: "Connectivity to the septic tank",
  },
  {
    value: "Whether the Soak pit was made functional",
    label: "Whether the Soak pit was made functional",
    name: "Whether the Soak pit was made functional",
  },
];
export const setBackTypes = [
  {
    value: "detach",
    label: "Detach",
    name: "detach",
  },
  {
    value: "semi-detach",
    label: "Semi-Detach",
    name: "semi-detach",
  },
  {
    value: "row-house",
    label: "Row-House",
    name: "row-house",
  },
];
export const floorNameList = [
  {
    value: "ground_floor",
    label: "Ground Floor",
    name: "Ground Floor",
  },
  {
    value: "first_floor",
    label: "First Floor",
    name: "First Floor",
  },
  {
    value: "second_floor",
    label: "Second Floor",
    name: "Second Floor",
  },
  {
    value: "third_floor",
    label: "Third Floor",
    name: "Third Floor",
  },
];
export const categoriesList = [
  {
    value: "electricity",
    label: "Electricity",
    name: "Electricity",
  },
  {
    value: "sewerage",
    label: "Sewerage",
    name: "Sewerage",
  },
  {
    value: "water",
    label: "Water",
    name: "Water",
  },
];
export const nocTypeList = [
  {
    value: "Temporary",
    label: "Temporary",
    name: "Temporary",
  },
  {
    value: "Permanent",
    label: "Permanent",
    name: "Permanent",
  },
];
export const appliedForList = [
  {
    value: "form_12",
    label: "Form 12",
    name: "Form 12",
  },
  {
    value: "form_26",
    label: "Form 26",
    name: "Form 26",
  },
];
export const typeOfAreaAsProposed = [
  {
    value: "Core",
    label: "Core",
    name: "Core",
  },
  {
    value: "Non-Core",
    label: "Non-Core",
    name: "Non-Core",
  },
  {
    value: "Restricted",
    label: "Restricted",
    name: "Restricted",
  },
  {
    value: "Green",
    label: "Green",
    name: "Green",
  },
  {
    value: "Heritage",
    label: "Heritage",
    name: "Heritage",
  },
  {
    value: "Sinking",
    label: "Sinking",
    name: "Sinking",
  },
  {
    value: "Sliding",
    label: "Sliding",
    name: "Sliding",
  },
  {
    value: "Other",
    label: "Other",
    name: "Other",
  },
];
export const typeOfIdProof = [
  {
    value: "Pan Card",
    label: "Pan Card",
    name: "Pan Card",
  },
  {
    value: "Aadhaar Card",
    label: "Aadhaar Card",
    name: "Aadhaar Card",
  },
  {
    value: "Driving License",
    label: "Driving License",
    name: "Driving License",
  },
  {
    value: "Voter Card",
    label: "Voter Card",
    name: "Voter Card",
  },
  {
    value: "Ration Card",
    label: "Ration Card",
    name: "Ration Card",
  },
  {
    value: "Passport",
    label: "Passport",
    name: "Passport",
  },
];
export const landUseZoneOptions = [
  {
    value: "Residential Use Zone",
    label: "Residential Use Zone",
    name: "Residential Use Zone",
  },
  {
    value: "Commercial Building",
    label: "Commercial Building",
    name: "Commercial Building",
  },
  {
    value: "Educational Building",
    label: "Educational Building",
    name: "Educational Building",
  },
  {
    value: "Institutional Buildings",
    label: "Institutional Buildings",
    name: "Institutional Buildings",
  },
  {
    value: "Assembly Buildings",
    label: "Assembly Buildings",
    name: "Assembly Buildings",
  },
  {
    value: "Officials Buildings",
    label: "Officials Buildings",
    name: "Officials Buildings",
  },
  {
    value: "Industrial Buildings",
    label: "Industrial Buildings",
    name: "Industrial Buildings",
  },
  {
    value: "Storage Buildings",
    label: "Storage Buildings",
    name: "Storage Buildings",
  },
];
export const natureOfConstructionOptions = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  {
    value: "Compounding",
    label: "Compounding",
    name: "Compounding",
  },
  {
    value: "Additional/Alteration/Revision",
    label: "Additional/Alteration/Revision",
    name: "Additional/Alteration/Revision",
  },
  {
    value: "Redevelopment/Reconstruction",
    label: "Redevelopment/Reconstruction",
    name: "Redevelopment/Reconstruction",
  },
  {
    value: "Revalidation/Time Extension",
    label: "Revalidation/Time Extension",
    name: "Revalidation/Time Extension",
  },
  {
    value: "Group Housing",
    label: "Group Housing",
    name: "Group Housing",
  },
];
export const natureOfConstructionOption = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  {
    value: "Compounding",
    label: "Compounding",
    name: "Compounding",
  },
  {
    value: "Addition Extension",
    label: "Addition Extension",
    name: "Addition Extension",
  },
  {
    value: "Revision",
    label: "Revision",
    name: "Revision",
  },
  {
    value: "Redevelopment/Reconstruction",
    label: "Redevelopment/Reconstruction",
    name: "Redevelopment/Reconstruction",
  },
  {
    value: "Revalidation/Time Extension",
    label: "Revalidation/Time Extension",
    name: "Revalidation/Time Extension",
  },
];
//natureOfConstructionOption2 temperarily created to remove compounding from dropdown
export const natureOfConstructionOption2 = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  {
    value: "Compounding",
    label: "Compounding",
    name: "Compounding",
  },
  {
    value: "Addition Extension",
    label: "Addition Extension",
    name: "Addition Extension",
  },
  {
    value: "Revision",
    label: "Revision",
    name: "Revision",
  },
  {
    value: "Redevelopment/Reconstruction",
    label: "Redevelopment/Reconstruction",
    name: "Redevelopment/Reconstruction",
  },
  {
    value: "Revalidation/Time Extension",
    label: "Revalidation/Time Extension",
    name: "Revalidation/Time Extension",
  },
];
export const natureOfCompounding = [
  {
    value: "Compounding application SUO-MOTO",
    label: "Compounding application SUO-MOTO",
    name: "Compounding application SUO-MOTO",
  },
  {
    value: "In response to notice",
    label: "In response to notice",
    name: "In response to notice",
  },
];
export const natureOfConstructionOptionComp = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  {
    value: "Additional/Alteration/Revision",
    label: "Additional/Alteration/Revision",
    name: "Additional/Alteration/Revision",
  },
  {
    value: "Redevelopment/Reconstruction",
    label: "Redevelopment/Reconstruction",
    name: "Redevelopment/Reconstruction",
  },
  {
    value: "Revalidation/Time Extension",
    label: "Revalidation/Time Extension",
    name: "Revalidation/Time Extension",
  },
  {
    value: "Compounding",
    label: "Compounding",
    name: "Compounding",
  },
];
export const selfApprovalnatureOfConstruction = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  {
    value: "Reconstruction",
    label: "Reconstruction",
    name: "Reconstruction",
  },
  {
    value: "Revision",
    label: "Revision",
    name: "Revision",
  },
  {
    value: "Revalidation",
    label: "Revalidation",
    name: "Revalidation",
  },
];
export const residentialNatureOfConstructionOptions = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  {
    value: "Additional/Alteration/Revision",
    label: "Additional/Alteration/Revision",
    name: "Additional/Alteration/Revision",
  },
  {
    value: "Redevelopment/Reconstruction",
    label: "Redevelopment/Reconstruction",
    name: "Redevelopment/Reconstruction",
  },
];
export const specialProjectOptions = [
  {
    value: "Building Design as per standard Drawing",
    label: "Building Design as per standard Drawing",
    name: "Building Design as per standard Drawing",
  },
  {
    value: "Standard condition as per Lease deed/freehold deed",
    label: "Standard condition as per Lease deed/freehold deed",
    name: "Standard condition as per Lease deed/freehold deed",
  },
  {
    value: "Other",
    label: "Other",
    name: "Other",
  },
];
export const landSubUseZoneOptions = [
  {
    value: "Residential Building Single Dwelling unit",
    label: "Residential Building Single Dwelling unit",
    name: "Residential Building Single Dwelling unit",
  },
  {
    value: "Residential Group Housing",
    label: "Residential Group Housing",
    name: "Residential Group Housing",
  },
  {
    value: "Residential Multi Unit",
    label: "Residential Multi Unit",
    name: "Residential Multi Unit",
  },
];
export const plotUseOptions = [
  {
    value: "Residential",
    label: "Residential",
    name: "Residential",
  },
  {
    value: "Commercial",
    label: "Commercial",
    name: "Commercial",
  },
  {
    value: "Educational",
    label: "Educational",
    name: "Educational",
  },
  {
    value: "Institutional",
    label: "Institutional",
    name: "Institutional",
  },
  {
    value: "Assembly",
    label: "Assembly",
    name: "Assembly",
  },
  {
    value: "Industrial",
    label: "Industrial",
    name: "Industrial",
  },
  {
    value: "Storage",
    label: "Storage",
    name: "Storage",
  },
];

export const plotSubUseOptions = [
  {
    value: "Row Houses",
    label: "Row Houses",
    name: "Row Houses",
  },
  {
    value: "Semi detached",
    label: "Semi detached",
    name: "Semi detached",
  },
  {
    value: "Detached",
    label: "Detached",
    name: "Detached",
  },
];
export const developmentAreaOption = [
  {
    value: "Built-up area",
    label: "Built-up area",
    name: "Built-up area",
  },
  {
    value: "Non-Built-up area",
    label: "Non-Built-up area",
    name: "Non-Built-up area",
  },
];

export const developmentAreaOptions = [
  {
    value: "Existing Builtup Area/Constructed Area",
    label: "Existing Builtup Area/Constructed Area",
    name: "Existing Builtup Area/Constructed Area",
  },
  {
    value: "Developed Area",
    label: "Developed Area",
    name: "Developed Area",
  },
  {
    value: "New Area",
    label: "New Area",
    name: "New Area",
  },
  {
    value: "Undeveloped Area",
    label: "Undeveloped Area",
    name: "Undeveloped Area",
  },
  {
    value: "Undefined Area",
    label: "Undefined Area",
    name: "Undefined Area",
  },
];
export const subdevelopmentOptions = [
  {
    value: "NA",
    label: "NA",
    name: "NA",
  },
  {
    value: "Metro City Area",
    label: "Metro City Area",
    name: "Metro City Area",
  },
  {
    value: "Village Area",
    label: "Village Area",
    name: "Village Area",
  },
  {
    value: "Other Town Area",
    label: "Other Town Area",
    name: "Other Town Area",
  },
];

export const planOnOptions = [
  {
    value: "Approved Schemes",
    label: "Approved Schemes",
    name: "Approved Schemes",
  },
  {
    value: "Private Approved Schemes",
    label: "Private Approved Schemes",
    name: "Private Approved Schemes",
  },
  {
    value: "Plot Area in 100 SqM built up residential land use",
    label: "Plot Area in 100 SqM built up residential land use",
    name: "Plot Area in 100 SqM built up residential land use",
  },
  {
    value: "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm",
    label: "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm",
    name: "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];

export const residentialPlanOnOptions = [
  {
    value: "Approved Schemes",
    label: "Approved Schemes",
    name: "Approved Schemes",
  },
  {
    value: "Private Approved Schemes",
    label: "Private Approved Schemes",
    name: "Private Approved Schemes",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];
export const proposedSiteOptions = [
  {
    value: "Scheme Developed by Authority",
    label: "Scheme Developed by Authority",
    name: "Scheme Developed by Authority",
  },
  {
    value: "Scheme Approved by Authority",
    label: "Scheme Approved by Authority",
    name: "Scheme Approved by Authority",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];

export const authoritiesName = [
  {
    value: "Vibhuti Khand GomtiNagar",
    label: "Vibhuti Khand GomtiNagar",
    name: "Vibhuti Khand GomtiNagar",
  },
  {
    value: "Nagar Palika Parishad Nawabganj",
    label: "Nagar Palika Parishad Nawabganj",
    name: "Nagar Palika Parishad Nawabganj",
  },
];
export const proposedSite = [
  {
    value: "Layout Developed by Authority",
    label: "Layout Developed by Authority",
    name: "Layout Developed by Authority",
  },
  {
    value: "Layout Approved by Authority",
    label: "Layout Approved by Authority",
    name: "Layout Approved by Authority",
  },
  // {
  //   value: "Others",
  //   label: "Others",
  //   name: "Others",
  // },
];
export const statesName = [
  {
    value: "Andaman and Nicobar Islands",
    label: "Andaman and Nicobar Islands",
    name: "Andaman and Nicobar Islands",
  },
  {
    value: "Andhra Pradesh",
    label: "Andhra Pradesh",
    name: "Andhra Pradesh",
  },
  {
    value: "Arunachal Pradesh",
    label: "Arunachal Pradesh",
    name: "Arunachal Pradesh",
  },
  {
    value: "Assam",
    label: "Assam",
    name: "Assam",
  },
  {
    value: "Bihar",
    label: "Bihar",
    name: "Bihar",
  },
  {
    value: "Chandigarh",
    label: "Chandigarh",
    name: "Chandigarh",
  },
  {
    value: "Chhattisgarh",
    label: "Chhattisgarh",
    name: "Chhattisgarh",
  },
  {
    value: "Dadra & Nagar Haveli & Daman and Diu",
    label: "Dadra & Nagar Haveli & Daman and Diu",
    name: "Dadra & Nagar Haveli & Daman and Diu",
  },
  {
    value: "Delhi",
    label: "Delhi",
    name: "Delhi",
  },
  {
    value: "Goa",
    label: "Goa",
    name: "Goa",
  },
  {
    value: "Gujarat",
    label: "Gujarat",
    name: "Gujarat",
  },
  {
    value: "Haryana",
    label: "Haryana",
    name: "Haryana",
  },
  {
    value: "Himachal Pradesh",
    label: "Himachal Pradesh",
    name: "Himachal Pradesh",
  },
  {
    value: "Jammu and Kashmir",
    label: "Jammu and Kashmir",
    name: "Jammu and Kashmir",
  },
  {
    value: "Jharkhand",
    label: "Jharkhand",
    name: "Jharkhand",
  },
  {
    value: "Karnataka",
    label: "Karnataka",
    name: "Karnataka",
  },
  {
    value: "Kerala",
    label: "Kerala",
    name: "Kerala",
  },
  {
    value: "Ladakh",
    label: "Ladakh",
    name: "Ladakh",
  },
  {
    value: "Lakshadweep",
    label: "Lakshadweep",
    name: "Lakshadweep",
  },
  {
    value: "Madhya Pradesh",
    label: "Madhya Pradesh",
    name: "Madhya Pradesh",
  },
  {
    value: "Maharashtra",
    label: "Maharashtra",
    name: "Maharashtra",
  },
  {
    value: "Manipur",
    label: "Manipur",
    name: "Manipur",
  },
  {
    value: "Meghalaya",
    label: "Meghalaya",
    name: "Meghalaya",
  },
  {
    value: "Mizoram",
    label: "Mizoram",
    name: "Mizoram",
  },
  {
    value: "Nagaland",
    label: "Nagaland",
    name: "Nagaland",
  },
  {
    value: "Odisha",
    label: "Odisha",
    name: "Odisha",
  },
  {
    value: "Puducherry",
    label: "Puducherry",
    name: "Puducherry",
  },
  {
    value: "Punjab",
    label: "Punjab",
    name: "Punjab",
  },
  {
    value: "Rajasthan",
    label: "Rajasthan",
    name: "Rajasthan",
  },
  {
    value: "Sikkim",
    label: "Sikkim",
    name: "Sikkim",
  },
  {
    value: "Tamil Nadu",
    label: "Tamil Nadu",
    name: "Tamil Nadu",
  },
  {
    value: "Telangana",
    label: "Telangana",
    name: "Telangana",
  },
  {
    value: "Tripura",
    label: "Tripura",
    name: "Tripura",
  },
  {
    value: "Uttar Pradesh",
    label: "Uttar Pradesh",
    name: "Uttar Pradesh",
  },
  {
    value: "Uttarakhand",
    label: "Uttarakhand",
    name: "Uttarakhand",
  },
  {
    value: "West Bengal",
    label: "West Bengal",
    name: "West Bengal",
  },
];
export const schemesData = [
  {
    value: "Radhika Vihar Yojna no 1 Mathura",
    label: "Radhika Vihar Yojna no 1 Mathura",
    name: "Radhika Vihar Yojna no 1 Mathura",
  },
  {
    value: "Krishna Vihar Yojna no 2 Mathura",
    label: "Krishna Vihar Yojna no 2 Mathura",
    name: "Krishna Vihar Yojna no 2 Mathura",
  },
  {
    value: "Yojna NO 1 Mainpuri",
    label: "Yojna NO 1 Mainpuri",
    name: "Yojna NO 1 Mainpuri",
  },
  {
    value: "Kasganj Yojna",
    label: "Kasganj Yojna",
    name: "Kasganj Yojna",
  },
  {
    value: "Yojna no 1 Hathras",
    label: "Yojna no 1 Hathras",
    name: "Yojna no 1 Hathras",
  },
  {
    value: "Suhagnagar Yojna Firojabad Sector 1",
    label: "Suhagnagar Yojna Firojabad Sector 1",
    name: "Suhagnagar Yojna Firojabad Sector 1",
  },
  {
    value: "Suhagnagar Yojna Firojabad Sector 2",
    label: "Suhagnagar Yojna Firojabad Sector 2",
    name: "Suhagnagar Yojna Firojabad Sector 2",
  },
  {
    value: "Suhagnagar Yojna Firojabad Sector 3",
    label: "Suhagnagar Yojna Firojabad Sector 3",
    name: "Suhagnagar Yojna Firojabad Sector 3",
  },
  {
    value: "Suhagnagar Yojna Firojabad Sector 4",
    label: "Suhagnagar Yojna Firojabad Sector 4",
    name: "Suhagnagar Yojna Firojabad Sector 4",
  },
];
export const roles = [
  {
    value: "BPA_ARCHITECT",
    label: "BPA_ARCHITECT",
    name: "BPA_ARCHITECT",
  },
  {
    value: "BPA_ENGINEER",
    label: "BPA_ENGINEER",
    name: "BPA_ENGINEER",
  },
  {
    value: "BPA_TOWNPLANNER",
    label: "BPA_TOWNPLANNER",
    name: "BPA_TOWNPLANNER",
  },
  {
    value: "BPA_STRUCTURALENGINEER",
    label: "BPA_STRUCTURALENGINEER",
    name: "BPA_STRUCTURALENGINEER",
  },
];

export const realEstateProjectTypesList = [
  {
    value: "group_housing",
    label: "Group Housing Project",
    name: "Group Housing Project",
  },
  {
    value: "plotted_development",
    label: "Plotted Development Projects",
    name: "Plotted Development Projects",
  },
  {
    value: "mixed_development",
    label: "Residential/Commercial or Mixed Development Projects",
    name: "Residential/Commercial or Mixed Development Projects",
  },
  {
    value: "commercial",
    label: "Commercial Project",
    name: "Commercial Project",
  },
  {
    value: "integrated",
    label: "Integrated Townships/New Townships/Smart Townships",
    name: "Integrated Townships/New Townships/Smart Townships",
  },
];
export const applicantStatusList = [
  {
    value: "individual_association_family",
    label: "Individual OR Association of Persons OR Joint Family",
    name: "Individual OR Association of Persons OR Joint Family",
  },
  {
    value: "firm_society_company",
    label: "Firm OR Co-operative Society OR Company",
    name: "Firm OR Co-operative Society OR Company",
  },
];
export const nameofConcernedList = [
  {
    value: "mc",
    label: "MC",
    name: "MC",
  },
  {
    value: "ulb",
    label: "ULB",
    name: "ULB",
  },
  {
    value: "panchayat",
    label: "Panchayat",
    name: "Panchayat",
  },
];
// export const natureOfTowerList = [
//   {
//     value: "master_Plan",
//     label: "Master Plan",
//     name: "Master Plan",
//   }, {
//     value: "layout_Plan",
//     label: "Layout Plan",
//     name: "Layout Plan",
//   },
// ];
export const natureOfTowerList = [
  {
    value: "master_Plan",
    label: "Master Plan",
    name: "Master Plan",
  },
  {
    value: "land_use",
    label: "Land Use",
    name: "Land Use",
  },
];

export const landUsesTypeList = [
  {
    value: "Residential",
    label: "Residential",
    name: "Residential",
  },
  {
    value: "Commercial",
    label: "Commercial",
    name: "Commercial",
  },
  {
    value: "Facilities",
    label: "Facilities",
    name: "Facilities",
  },
  {
    value: "Agriculture",
    label: "Agriculture",
    name: "Agriculture",
  },
  {
    value: "Recreation/Open Spaces/Green Belt",
    label: "Recreation/Open Spaces/Green Belt",
    name: "Recreation/Open Spaces/Green Belt",
  },
  {
    value: "Industrial",
    label: "Industrial",
    name: "Industrial",
  },
  {
    value: "Offices",
    label: "Offices",
    name: "Offices",
  },
  {
    value: "Transportation",
    label: "Transportation",
    name: "Transportation",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];
export const landUsesSchemeTypeList = [
  {
    value: "Residential",
    label: "Residential",
    name: "Residential",
  },
  {
    value: "Commercial",
    label: "Commercial",
    name: "Commercial",
  },
  {
    value: "Industrial",
    label: "Industrial",
    name: "Industrial",
  },
  {
    value: "Institutional",
    label: "Institutional",
    name: "Institutional",
  },
  {
    value: "Educational",
    label: "Educational",
    name: "Educational",
  },
  {
    value: "Community Facilities",
    label: "Community Facilities",
    name: "Community Facilities",
  },
  {
    value: "Health Facilities",
    label: "Health Facilities",
    name: "Health Facilities",
  },
  {
    value: "Offices",
    label: "Offices",
    name: "Offices",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];

export const subUsesTypeList = [
  {
    value: "Built up area/Gramin Abadi",
    label: "Built up area/Gramin Abadi",
    name: "Built up area/Gramin Abadi",
  },
  {
    value: "Residential",
    label: "Residential",
    name: "Residential",
  },
];
export const developmentPlans = [
  {
    value: "Master Plan",
    label: "Master Plan",
    name: "Master Plan",
  },
  {
    value: "Zonal Plan",
    label: "Zonal Plan",
    name: "Zonal Plan",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];

export const subUseCommercialList = [
  {
    value: "City Center",
    label: "City Center",
    name: "City Center",
  },
  {
    value: "District Business Center",
    label: "District Business Center",
    name: "District Business Center",
  },
  {
    value: "Mixed LandUse - 1",
    label: "Mixed LandUse - 1",
    name: "Mixed LandUse - 1",
  },
  {
    value: "Mixed LandUse - 2",
    label: "Mixed LandUse - 2",
    name: "Mixed LandUse - 2",
  },
  {
    value: "Other Commercial",
    label: "Other Commercial",
    name: "Other Commercial",
  },
  {
    value: "Storage/Godown/Warehousing",
    label: "Storage/Godown/Warehousing",
    name: "Storage/Godown/Warehousing",
  },
  {
    value: "Sub-City Center",
    label: "Sub-City Center",
    name: "Sub-City Center",
  },
  {
    value: "Vehicle Sales-Purchase House / Workshop / Accessories Center",
    label: "Vehicle Sales-Purchase House / Workshop / Accessories Center",
    name: "Vehicle Sales-Purchase House / Workshop / Accessories Center",
  },
  {
    value: "Wholesale Business Center",
    label: "Wholesale Business Center",
    name: "Wholesale Business Center",
  },
];

export const schemeTypeList = [
  {
    value: "Scheme",
    label: "Scheme",
    name: "Scheme",
  },
  {
    value: "Non Scheme",
    label: "Non Scheme",
    name: "Non Scheme",
  },
];

export const permissionTypeList = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  // {
  //   value: "Reconstruction",
  //   label: "Reconstruction",
  //   name: "Reconstruction",
  // },
];
export const planOnType = [
  {
    value: "Development Authority Approved Scheme",
    label: "Development Authority Approved Scheme",
    name: "Development Authority Approved Scheme",
  },
  {
    value: "Private Approved Scheme",
    label: "Private Approved Scheme",
    name: "Private Approved Scheme",
  },
];
export const tehsilData = [
  {
    value: "SADAR",
    label: "SADAR",
    name: "SADAR",
  },
  {
    value: "BAKHSHI KA TALAB",
    label: "BAKHSHI KA TALAB",
    name: "BAKHSHI KA TALAB",
  },
  {
    value: "MALIHABAD",
    label: "MALIHABAD",
    name: "MALIHABAD",
  },
  {
    value: "MOHANLAL GANJ",
    label: "MOHANLAL GANJ",
    name: "MOHANLAL GANJ",
  },
  {
    value: "SAROJNI NAGAR",
    label: "SAROJNI NAGAR",
    name: "SAROJNI NAGAR",
  },
];
export const schemeNameList = [
  {
    value: "Radhika Vihar Yojna no 1 Mathura",
    label: "Radhika Vihar Yojna no 1 Mathura",
    name: "Radhika Vihar Yojna no 1 Mathura",
  },
  {
    value: "Krishna Vihar Yojna no 2 Mathura",
    label: "Krishna Vihar Yojna no 2 Mathura",
    name: "Krishna Vihar Yojna no 2 Mathura",
  },
  {
    value: "Yojna NO 1 Mainpuri",
    label: "Yojna NO 1 Mainpuri",
    name: "Yojna NO 1 Mainpuri",
  },
  {
    value: "Kasganj Yojna",
    label: "Kasganj Yojna",
    name: "Kasganj Yojna",
  },
  {
    value: "Yojna no 1 Hathras",
    label: "Yojna no 1 Hathras",
    name: "Yojna no 1 Hathras",
  },
];
export const farLandUseTypes = [
  {
    value: "Residential (Group Housing)",
    label: "Residential (Group Housing)",
    name: "Residential (Group Housing)",
  },
  {
    value: "Commercial",
    label: "Commercial",
    name: "Commercial",
  },
  {
    value: "Mixed land",
    label: "Mixed land",
    name: "Mixed land",
  },
  {
    value: "Office/Organization",
    label: "Office/Organization",
    name: "Office/Organization",
  },
  {
    value: "Hotel",
    label: "Hotel",
    name: "Hotel",
  },
  {
    value: "Community and Social facilities",
    label: "Community and Social facilities",
    name: "Community and Social facilities",
  },
];
export const ResidentialUseList = [
  {
    value: "Residential Building Single Dwelling Unit",
    label: "Residential Building Single Dwelling Unit",
    name: "Residential Building Single Dwelling Unit",
  },
  {
    value: "Residential Group Housing",
    label: "Residential Group Housing",
    name: "Residential Group Housing",
  },
  {
    value: "Residentail Multi Unit",
    label: "Residentail Multi Unit",
    name: "Residentail Multi Unit",
  },
];
export const landSubUseTypes = [
  {
    value: "Group Housing",
    label: "Group Housing",
    name: "Group Housing",
  },
  {
    value: "City Center/Central Business District",
    label: "City Center/Central Business District",
    name: "City Center/Central Business District",
  },
  {
    value: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
    label: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
    name: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
  },
  {
    value: "Other Commercial",
    label: "Other Commercial",
    name: "Other Commercial",
  },
  {
    value: "Hotel",
    label: "Hotel",
    name: "Hotel",
  },
  {
    value: "Fruit and Vegetable Mandi",
    label: "Fruit and Vegetable Mandi",
    name: "Fruit and Vegetable Mandi",
  },
  {
    value: "Other Wholesale business",
    label: "Other Wholesale business",
    name: "Other Wholesale business",
  },
  {
    value: "Grain Market",
    label: "Grain Market",
    name: "Grain Market",
  },
  {
    value: "Primary and Nursary School",
    label: "Primary and Nursary School",
    name: "Primary and Nursary School",
  },
  {
    value: "High School/Intermediate/College",
    label: "High School/Intermediate/College",
    name: "High School/Intermediate/College",
  },
  {
    value: "Degree College",
    label: "Degree College",
    name: "Degree College",
  },
  {
    value: "High School/Intermediate",
    label: "High School/Intermediate",
    name: "High School/Intermediate",
  },
  {
    value: "Techinical Management College",
    label: "Techinical Management College",
    name: "Techinical Management College",
  },
  {
    value: "Community facilities",
    label: "Community facilities",
    name: "Community facilities",
  },
  {
    value: "Community center, Marrige Palace and Religious Building",
    label: "Community center, Marrige Palace and Religious Building",
    name: "Community center, Marrige Palace and Religious Building",
  },
  {
    value: "Other Organization center",
    label: "Other Organization center",
    name: "Other Organization center",
  },
  {
    value: "Godown",
    label: "Godown",
    name: "Godown",
  },
  {
    value: "Building constrution material yard",
    label: "Building constrution material yard",
    name: "Building constrution material yard",
  },
  {
    value: "Clinic and Dispensary",
    label: "Clinic and Dispensary",
    name: "Clinic and Dispensary",
  },
  {
    value: "Nursing Home with 50 Beds Capacity",
    label: "Nursing Home with 50 Beds Capacity",
    name: "Nursing Home with 50 Beds Capacity",
  },
  {
    value: "Hospital more than 50 Beds",
    label: "Hospital more than 50 Beds",
    name: "Hospital more than 50 Beds",
  },
  {
    value: "Hospital upto 50 - 100 Beds",
    label: "Hospital upto 50 - 100 Beds",
    name: "Hospital upto 50 - 100 Beds",
  },
  {
    value: "Hospital more than 100 Beds",
    label: "Hospital more than 100 Beds",
    name: "Hospital more than 100 Beds",
  },
  {
    value: "Filling station",
    label: "Filling station",
    name: "Filling station",
  },
  {
    value: "Filling station cum service center",
    label: "Filling station cum service center",
    name: "Filling station cum service center",
  },
  {
    value: "Petrol Pump, Service Garage, Repair shop etc.",
    label: "Petrol Pump, Service Garage, Repair shop etc.",
    name: "Petrol Pump, Service Garage, Repair shop etc.",
  },
];
export const landSubUseTypes2 = [
  {
    value: "Group Housing",
    label: "Group Housing",
    name: "Group Housing",
  },
  {
    value: "City Center/Central Business District",
    label: "City Center/Central Business District",
    name: "City Center/Central Business District",
  },
  {
    value: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
    label: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
    name: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
  },
  {
    value: "Other Commercial",
    label: "Other Commercial",
    name: "Other Commercial",
  },
  {
    value: "Plotted Development",
    label: "Plotted Development",
    name: "Plotted Development",
  },
  {
    value: "Hotel",
    label: "Hotel",
    name: "Hotel",
  },
  {
    value: "Fruit and Vegetable Mandi",
    label: "Fruit and Vegetable Mandi",
    name: "Fruit and Vegetable Mandi",
  },
  {
    value: "Other Wholesale business",
    label: "Other Wholesale business",
    name: "Other Wholesale business",
  },
  {
    value: "Grain Market",
    label: "Grain Market",
    name: "Grain Market",
  },
  {
    value: "Primary and Nursery School",
    label: "Primary and Nursery School",
    name: "Primary and Nursery School",
  },
  {
    value: "High School/Intermediate/College",
    label: "High School/Intermediate/College",
    name: "High School/Intermediate/College",
  },
  {
    value: "Degree College",
    label: "Degree College",
    name: "Degree College",
  },
  {
    value: "High School/Intermediate",
    label: "High School/Intermediate",
    name: "High School/Intermediate",
  },
  {
    value: "Techinical Management College",
    label: "Techinical Management College",
    name: "Techinical Management College",
  },
  {
    value: "Community facilities",
    label: "Community facilities",
    name: "Community facilities",
  },
  {
    value: "Community center, Marrige Palace and Religious Building",
    label: "Community center, Marrige Palace and Religious Building",
    name: "Community center, Marrige Palace and Religious Building",
  },
  {
    value: "Other Organization center",
    label: "Other Organization center",
    name: "Other Organization center",
  },
  {
    value: "Godown",
    label: "Godown",
    name: "Godown",
  },
  {
    value: "Building constrution material yard",
    label: "Building constrution material yard",
    name: "Building constrution material yard",
  },
  {
    value: "Clinic and Dispensary",
    label: "Clinic and Dispensary",
    name: "Clinic and Dispensary",
  },
  {
    value: "Nursing Home with 50 Beds Capacity",
    label: "Nursing Home with 50 Beds Capacity",
    name: "Nursing Home with 50 Beds Capacity",
  },
  {
    value: "Hospital more than 50 Beds",
    label: "Hospital more than 50 Beds",
    name: "Hospital more than 50 Beds",
  },
  {
    value: "Hospital upto 50 - 100 Beds",
    label: "Hospital upto 50 - 100 Beds",
    name: "Hospital upto 50 - 100 Beds",
  },
  {
    value: "Hospital more than 100 Beds",
    label: "Hospital more than 100 Beds",
    name: "Hospital more than 100 Beds",
  },
  {
    value: "Filling station",
    label: "Filling station",
    name: "Filling station",
  },
  {
    value: "Filling station cum service center",
    label: "Filling station cum service center",
    name: "Filling station cum service center",
  },
  {
    value: "Petrol Pump, Service Garage, Repair shop etc.",
    label: "Petrol Pump, Service Garage, Repair shop etc.",
    name: "Petrol Pump, Service Garage, Repair shop etc.",
  },
];

export const landUseList = [
  {
    value: "General Permissible",
    label: "General Permissible",
    name: "General Permissible",
  },
  {
    value: "Conditional Permissible",
    label: "Conditional Permissible",
    name: "Conditional Permissible",
  },
  {
    value: "Special Permissible",
    label: "Special Permissible",
    name: "Special Permissible",
  },
];
export const mandatoryConditions = [
  {
    value: "Watchman/sentry accommodation on ground floor",
    label: "Watchman/sentry accommodation on ground floor",
    name: "Watchman/sentry accommodation on ground floor",
  },
  {
    value: "Housing on upper floors except ground floor",
    label: "Housing on upper floors except ground floor",
    name: "Housing on upper floors except ground floor",
  },
  {
    value:
      "10 percent of the floor area of ​​the subsequent floors except the ground floor or 10 percent of the layout map only for the concerned employees",
    label:
      "10 percent of the floor area of ​​the subsequent floors except the ground floor or 10 percent of the layout map only for the concerned employees",
    name:
      "10 percent of the floor area of ​​the subsequent floors except the ground floor or 10 percent of the layout map only for the concerned employees",
  },
  {
    value: "On minimum 18 meter wide road",
    label: "On minimum 18 meter wide road",
    name: "On minimum 18 meter wide road",
  },
  {
    value: "According to the relief map and 10 percent of the maximum coverage permissible on the plot.",
    label: "According to the relief map and 10 percent of the maximum coverage permissible on the plot.",
    name: "According to the relief map and 10 percent of the maximum coverage permissible on the plot.",
  },
  {
    value: "On minimum 24 meter wide road",
    label: "On minimum 24 meter wide road",
    name: "On minimum 24 meter wide road",
  },
  {
    value: "Up to a maximum of 10 beds on a minimum 12 meter wide track.",
    label: "Up to a maximum of 10 beds on a minimum 12 meter wide track.",
    name: "Up to a maximum of 10 beds on a minimum 12 meter wide track.",
  },
  {
    value: "Up to a maximum of 30 beds on a minimum 18 meter wide track",
    label: "Up to a maximum of 30 beds on a minimum 18 meter wide track",
    name: "Up to a maximum of 30 beds on a minimum 18 meter wide track",
  },
  {
    value: "30 percent of the maximum permissible total coverage on a minimum 24 meter wide road.",
    label: "30 percent of the maximum permissible total coverage on a minimum 24 meter wide road.",
    name: "30 percent of the maximum permissible total coverage on a minimum 24 meter wide road.",
  },
  {
    value: "Storage of goods other than inflammable, perishable and emergency goods",
    label: "Storage of goods other than inflammable, perishable and emergency goods",
    name: "Storage of goods other than inflammable, perishable and emergency goods",
  },
  {
    value: "Only at designated places outside the developed population of the city",
    label: "Only at designated places outside the developed population of the city",
    name: "Only at designated places outside the developed population of the city",
  },
  {
    value: "Up to 5 Horse Power (as per Annexure 2) on minimum 12 meter wide track",
    label: "Up to 5 Horse Power (as per Annexure 2) on minimum 12 meter wide track",
    name: "Up to 5 Horse Power (as per Annexure 2) on minimum 12 meter wide track",
  },
  {
    value: "Of the total area of ​​the land plot. 10 percent as per the plan approved by the competent authority",
    label: "Of the total area of ​​the land plot. 10 percent as per the plan approved by the competent authority",
    name: "Of the total area of ​​the land plot. 10 percent as per the plan approved by the competent authority",
  },
  {
    value: "Of the total area of ​​the land plot. 02 percent as per the draft plan approved by the competent authority.",
    label: "Of the total area of ​​the land plot. 02 percent as per the draft plan approved by the competent authority.",
    name: "Of the total area of ​​the land plot. 02 percent as per the draft plan approved by the competent authority.",
  },
  {
    value: "For incidental use only",
    label: "For incidental use only",
    name: "For incidental use only",
  },
  {
    value: "Only in open form and at temporarily designated places.",
    label: "Only in open form and at temporarily designated places.",
    name: "Only in open form and at temporarily designated places.",
  },
  {
    value: "Related only to infectious diseases",
    label: "Related only to infectious diseases",
    name: "Related only to infectious diseases",
  },
  {
    value: "On a minimum 30 meter wide road",
    label: "On a minimum 30 meter wide road",
    name: "On a minimum 30 meter wide road",
  },
  {
    value: "Upto 10 Horse Power (as per Annexure-3)",
    label: "Upto 10 Horse Power (as per Annexure-3)",
    name: "Upto 10 Horse Power (as per Annexure-3)",
  },
  {
    value: "The city will be at a minimum distance of 300 meters from the proposed main roads, rural population and urban limits.",
    label: "The city will be at a minimum distance of 300 meters from the proposed main roads, rural population and urban limits.",
    name: "The city will be at a minimum distance of 300 meters from the proposed main roads, rural population and urban limits.",
  },
  {
    value: "Only for the use of the related facility and a maximum of 01 percent of the land cover inside the premises.",
    label: "Only for the use of the related facility and a maximum of 01 percent of the land cover inside the premises.",
    name: "Only for the use of the related facility and a maximum of 01 percent of the land cover inside the premises.",
  },
  {
    value: "Up to 5 percent of the total area of ​​the site",
    label: "Up to 5 percent of the total area of ​​the site",
    name: "Up to 5 percent of the total area of ​​the site",
  },
  {
    value: "On minimum 12 meter wide road",
    label: "On minimum 12 meter wide road",
    name: "On minimum 12 meter wide road",
  },
  {
    value:
      "On minimum 30 meter wide road, 10 percent of the current residential sector rate or circle rate (whichever is higher) along with impact fee",
    label:
      "On minimum 30 meter wide road, 10 percent of the current residential sector rate or circle rate (whichever is higher) along with impact fee",
    name:
      "On minimum 30 meter wide road, 10 percent of the current residential sector rate or circle rate (whichever is higher) along with impact fee",
  },
  {
    value: "30 percent of the maximum permissible total coverage on a minimum 18 meter wide road",
    label: "30 percent of the maximum permissible total coverage on a minimum 18 meter wide road",
    name: "30 percent of the maximum permissible total coverage on a minimum 18 meter wide road",
  },
  {
    value: "On minimum 12 meter wide path and only on ground level",
    label: "On minimum 12 meter wide path and only on ground level",
    name: "On minimum 12 meter wide path and only on ground level",
  },
  {
    value: "With maximum 5 percent ground cover of main/regional roads which can be constructed on the side part of the plot in question",
    label: "With maximum 5 percent ground cover of main/regional roads which can be constructed on the side part of the plot in question",
    name: "With maximum 5 percent ground cover of main/regional roads which can be constructed on the side part of the plot in question",
  },
  {
    value: "Only in bus stands approved by the Transport Corporation",
    label: "Only in bus stands approved by the Transport Corporation",
    name: "Only in bus stands approved by the Transport Corporation",
  },
];

export const yesNoRadioList = [
  {
    value: "Yes",
    label: "Yes",
    name: "Yes",
  },
  {
    value: "No",
    label: "No",
    name: "No",
  },
];

export const solidWasteDisposal = [
  {
    value: "STP",
    label: "STP",
    name: "STP",
  },
  {
    value: "Septic",
    label: "Septic",
    name: "Septic",
  },
  {
    value: "Sewerage",
    label: "Sewerage",
    name: "Sewerage",
  },
];
export const garbageCollection = [
  {
    value: "Private",
    label: "Private",
    name: "Private",
  },
  {
    value: "Government",
    label: "Government",
    name: "Government",
  },
];
export const publicSewerageOrSepticTank = [
  {
    value: "Public Sewerage Plan",
    label: "Public Sewerage Plan",
    name: "Public Sewerage Plan",
  },
  {
    value: "Septic Tank",
    label: "Septic Tank",
    name: "Septic Tank",
  },
];
export const farPayment = [
  {
    value: "Full Payment",
    label: "Full Payment",
    name: "Full Payment",
  },
  {
    value: "Installments",
    label: "Installments",
    name: "Installments",
  },
];
export const towerToBeProposedList = [
  {
    value: "on_ground",
    label: "On Ground",
    name: "On Ground",
  },
  {
    value: "at_rooftop",
    label: "At Rooftop",
    name: "At Rooftop",
  },
];
export const nonCoreOther = [
  {
    value: "Core",
    label: "Core",
  },
  {
    value: "Non Core",
    label: "Non Core",
  },
  {
    value: "Other",
    label: "Other",
  },
  {
    value: "Restricted",
    label: "Restricted",
  },
  {
    value: "Green",
    label: "Green",
  },
  {
    value: "Heritage",
    label: "Heritage",
  },
  {
    value: "Sinking",
    label: "Sinking",
  },
  {
    value: "Sliding",
    label: "Sliding",
  },
];
export const submittedNotSubmitted = [
  {
    value: "submitted",
    label: "Submitted",
  },
  {
    value: "notSubmitted",
    label: "Not Submitted",
  },
];
export const constructionType = [
  {
    value: "Built Up",
    label: "Built Up",
  },
  {
    value: "Develop",
    label: "Develop",
  },
  {
    value: "Undevelop",
    label: "Undevelop",
  },
];
export const genderData = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },
  {
    value: "Transgender",
    label: "Transgender",
  },
];
export const nocData = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "NA",
    label: "NA",
  },
];
export const registrationTypes = [
  {
    value: "Architect",
    label: "Architect",
  },
  {
    value: "Town Planner",
    label: "Town Planner",
  },
  {
    value: "Graduate Civil Engineer",
    label: "Graduate Civil Engineer",
  },
  {
    value: "Supervisor",
    label: "Supervisor",
  },
  {
    value: "Structural Engineer",
    label: "Structural Engineer",
  },
  {
    value: "Landscape Architect",
    label: "Landscape Architect",
  },
  {
    value: "Urban Designer",
    label: "Urban Designer",
  },
  {
    value: "Engineers for Utility Services",
    label: "Engineers for Utility Services",
  },
];
export const appealApplicationStatus = [
  {
    value: "Individual",
    label: "Individual",
  },
  {
    value: "Firm",
    label: "Firm",
  },
  {
    value: "Company",
    label: "Company",
  },
  {
    value: "Association Of Person",
    label: "Association of Person",
  },
  {
    value: "Co-operative Society",
    label: "Co-operative Society",
  },
  {
    value: "Other",
    label: "Other",
  },
];
export const existingLandUse = [
  {
    value: "Commercial",
    label: "Commercial",
  },
  {
    value: "Industrial",
    label: "Industrial",
  },
  {
    value: "Residential",
    label: "Residential",
  },
  {
    value: "Agriculture",
    label: "Agriculture",
  },
  {
    value: "PublicSemipublic",
    label: "Public Semi public",
  },
];
export const typeOfLandForDevelopment = [
  {
    value: "Commercial",
    label: "Commercial",
    name: "Commercial",
  },
  {
    value: "Industrial",
    label: "Industrial",
    name: "Industrial",
  },
  {
    value: "Residential",
    label: "Residential",
    name: "Residential",
  },

  {
    value: "PublicSemipublic",
    label: "Public Semi public",
    name: "Public Semi public",
  },
];
export const typeOfConstruction = [
  {
    value: "Row House",
    label: "Row House",
    name: "Row House",
  },
  {
    value: "Detach House",
    label: "Detach House",
    name: "Detach House",
  },
  {
    value: "Semi Detach House",
    label: "Semi Detach House",
    name: "Semi Detach House",
  },
];

export const typeOfConstructionResidential = [
  {
    value: "Row House",
    label: "Row House",
    name: "Row House",
  },
  {
    value: "Detach House",
    label: "Detach House",
    name: "Detach House",
  },
  {
    value: "Semi Detach House",
    label: "Semi Detach House",
    name: "Semi Detach House",
  },
];

export const natureOfConstruction = [
  {
    value: "New",
    label: "New",
    name: "New",
  },
  {
    value: "Additional/Alteration",
    label: "Additional/Alteration",
    name: "Additional/Alteration",
  },
  {
    value: "Redevelopment/Reconstruction",
    label: "Redevelopment/Reconstruction",
    name: "Redevelopment/Reconstruction",
  },
  {
    value: "Standard Design",
    label: "Standard Design",
    name: "Standard Design",
  },
];
export const typeOfConstructionCommercial = [
  {
    value: "Shops",
    label: "Shops",
    name: "Shops",
  },
  {
    value: "Shopping-Complex",
    label: "Shopping-Complex",
    name: "Shopping-Complex",
  },
  {
    value: "Tourism-Unit",
    label: "Tourism-Unit",
    name: "Tourism-Unit",
  },
  {
    value: "Cinema/Cineplex",
    label: "Cinema/Cineplex",
    name: "Cinema/Cineplex",
  },
  {
    value: "Multiplexes",
    label: "Multiplexes",
    name: "Multiplexes",
  },
  {
    value: "Multi-level parking",
    label: "Multi-level parking",
    name: "Multi-level parking",
  },
  {
    value: "Others",
    label: "Others",
    name: "Others",
  },
];
export const typeOfConstructionIndustrial = [
  {
    value: "Small Scale Industries",
    label: "Small Scale Industries",
    name: "Small Scale Industries",
  },
  {
    value: "Services/ Light scale In-dustries",
    label: "Services/ Light scale In-dustries",
    name: "Services/ Light scale In-dustries",
  },
  {
    value: "Medium Scale Industries",
    label: "Medium Scale Industries",
    name: "Medium Scale Industries",
  },
  {
    value: "Large and Heavy Scale Industries",
    label: "Large and Heavy Scale Industries",
    name: "Large and Heavy Scale Industries",
  },
];
export const typeOfConstructionPublic = [
  {
    value: "Educational Building",
    label: "Educational Building",
    name: "Educational Building",
  },
  {
    value: "Police Station, Fire Station Buildings",
    label: "Police Station, Fire Station Buildings",
    name: "Police Station, Fire Station Buildings",
  },
  {
    value: "Medical Buildings",
    label: "Medical Buildings",
    name: "Medical Buildings",
  },
  {
    value: "Community Hall",
    label: "Community Hall",
    name: "Community Hall",
  },
  {
    value: "Library/Religious Building",
    label: "Library/Religious Building",
    name: "Library/Religious Building",
  },
  {
    value: "Government-Semi Govern-ment offices Buildings",
    label: "Government-Semi Govern-ment offices Buildings",
    name: "Government-Semi Govern-ment offices Buildings",
  },
];
export const floorTypeList = [
  {
    code: "hp.tcpsolan",
    id: 1,
    name: "Basement",
  },
  {
    code: "hp.tcpsolan",
    id: 2,
    name: "Ground Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 3,
    name: "1st Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 4,
    name: "2nd Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 5,
    name: "3rd Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 6,
    name: "4th Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 7,
    name: "5th Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 8,
    name: "6th Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 9,
    name: "7th Floor",
  },
  {
    code: "hp.tcpsolan",
    id: 10,
    name: "8th Floor",
  },
];
export const useTypeList = [
  {
    value: "Commercial",
    label: "Commercial",
    name: "Commercial",
  },
  {
    value: "Industrial",
    label: "Industrial",
    name: "Industrial",
  },
  {
    value: "Public and Semi-Public",
    label: "PublicSemipublic",
    name: "Public and Semi-Public",
  },
  {
    value: "Residential",
    label: "Residential",
    name: "Residential",
  },
];

export const typeOfCluInvolved = [
  {
    value: "For change of Land use from the original Use",
    label: "For change of Land use from the original Use",
  },
  {
    value: "IDP/Development plan to other land use",
    label: "IDP/Development plan to other land use",
  },
  /*
  {
    value: "IDP/Develop-ment plan to other Use",
    label: "IDP/Develop-ment plan to other Use",
  },
  {
    value: "Plot No./Khasra No.",
    label: "Plot No./Khasra No.",
  },
  {
    value: " Plot Area",
    label: " Plot Area",
  },
  */
];

export const natureOfTower = [
  {
    value: "Unauthorised",
    label: "Unauthorised",
  },
  {
    value: "New Installation ",
    label: "New Installation ",
  },
];

export const towerToBeProposed = [
  {
    value: "OnGround",
    label: "On Ground",
  },
  {
    value: "At Roof top ",
    label: "At Roof top ",
  },
];

export const DistrictsData = [
  {
    value: "Bilaspur",
    label: "Bilaspur",
  },
  {
    value: "Chamba",
    label: "Chamba",
  },
  {
    value: "Hamirpur",
    label: "Hamirpur",
  },
  {
    value: "Kangra",
    label: "Kangra",
  },
  {
    value: "Kinnaur",
    label: "Kinnaur",
  },
  {
    value: "Lahaul and Spiti",
    label: "Lahaul and Spiti",
  },
  {
    value: "Mandi",
    label: "Mandi",
  },
  {
    value: "Shimla",
    label: "Shimla",
  },
  {
    value: "Sirmaur",
    label: "Sirmaur",
  },
];

export const NamesOFULB = [
  {
    value: "Corp",
    label: "Corp",
  },
  {
    value: "Council",
    label: "Council",
  },
  {
    value: "NP",
    label: "NP",
  },
];

export const statesData = [
  {
    value: "Andaman and Nicobar",
    label: "Andaman and Nicobar",
  },
  {
    value: "Andhra Pradesh",
    label: "Andhra Pradesh",
  },
  {
    value: "Arunachal Pradesh",
    label: "Arunachal Pradesh",
  },
  {
    value: "Assam",
    label: "Assam",
  },
  {
    value: "Bihar",
    label: "Bihar",
  },
  {
    value: "Chandigarh",
    label: "Chandigarh",
  },
  {
    value: "Chhattisgarh",
    label: "Chhattisgarh",
  },
  {
    value: "Delhi",
    label: "Delhi",
  },
  {
    value: "Goa",
    label: "Goa",
  },
  {
    value: "Gujarat",
    label: "Gujarat",
  },
  {
    value: "Haryana",
    label: "Haryana",
  },
  {
    value: "Uttar Pradesh",
    label: "Uttar Pradesh",
  },
  {
    value: "Jharkhand",
    label: "Jharkhand",
  },
  {
    value: "Karnataka",
    label: "Karnataka",
  },
  {
    value: "Kerala",
    label: "Kerala",
  },
  {
    value: "Madhya Pradesh",
    label: "Madhya Pradesh",
  },
  {
    value: "Maharashtra",
    label: "Maharashtra",
  },
  {
    value: "Manipur",
    label: "Manipur",
  },
  {
    value: "Meghalaya",
    label: "Meghalaya",
  },
  {
    value: "Mizoram",
    label: "Mizoram",
  },
  {
    value: "Nagaland",
    label: "Nagaland",
  },
  {
    value: "Odisha",
    label: "Odisha",
  },
  {
    value: "Puducherry",
    label: "Puducherry",
  },
  {
    value: "Punjab",
    label: "Punjab",
  },
  {
    value: "Rajasthan",
    label: "Rajasthan",
  },
  {
    value: "Sikkim",
    label: "Sikkim",
  },
  {
    value: "Tamil Nadu",
    label: "Tamil Nadu",
  },
  {
    value: "Telangana",
    label: "Telangana",
  },
  {
    value: "Tripura",
    label: "Tripura",
  },
  {
    value: "Uttar Pradesh",
    label: "Uttar Pradesh",
  },
  {
    value: "Uttarakhand",
    label: "Uttarakhand",
  },
  {
    value: "West Bengal",
    label: "West Bengal",
  },
];

export const PaymentHeads = [
  {
    value: "Payment Summary",
    label: "Payment Summary",
  },
  {
    value: "Processing Fee",
    label: "Processing Fee",
  },
  {
    value: "e-charge (2.00)%",
    label: "e-charge (2.00)%",
  },
  {
    value: "Muck Charges",
    label: "Muck Charges",
  },
  {
    value: "Total Payment Amount",
    label: "Total Payment Amount",
  },

  {
    value: "All",
    label: "All",
  },
];
export const paymentStatus = [
  {
    value: "Not Done",
    label: "Not Done",
    name: "Not Done",
  },
  {
    value: "Under Process",
    label: "Under Process",
    name: "Under Process",
  },
];
export const registryStatus = [
  {
    value: "Not Done",
    label: "Not Done",
    name: "Not Done",
  },
  {
    value: "Under Process",
    label: "Under Process",
    name: "Under Process",
  },
  {
    value: "Done",
    label: "Done",
    name: "Done",
  },
];

export const uptodatePaymentStatus = [
  {
    value: "Outstanding",
    label: "Outstanding",
    name: "Outstanding",
  },
  {
    value: "Running",
    label: "Running",
    name: "Running",
  },
  {
    value: "Full Payment",
    label: "Full Payment",
    name: "Full Payment",
  },
];
export const NotifiedArea = [
  {
    value: "Hatkoti",
    label: "Hatkoti",
  },
  {
    value: "Sarahan",
    label: "Sarahan",
  },
  {
    value: "Shoghi",
    label: "Shoghi",
  },
  {
    value: "Kufri",
    label: "Kufri",
  },
  {
    value: "Barog",
    label: "Barog",
  },
  {
    value: "Harat",
    label: "Harat",
  },
];
export const VillagesData = [
  {
    value: "Nako",
    label: "Nako",
  },
  {
    value: "Kardang",
    label: "Kardang",
  },
  {
    value: "Chitkul",
    label: "Chitkul",
  },
  {
    value: "Kibber",
    label: "KIbber",
  },
  {
    value: "Komic",
    label: "KOmic",
  },
  {
    value: "Langza",
    label: "Langza",
  },
  {
    value: "Dhankar",
    label: "Dhankar",
  },
  {
    value: "Barot",
    label: "Barot",
  },
  {
    value: "Malana",
    label: "Malana",
  },
];
export const WardData = [
  {
    value: "Bharari",
    label: "Bharari",
  },
  {
    value: "Kaithu",
    label: "Kaithu",
  },
  {
    value: "Annadale",
    label: "Annadale",
  },
  {
    value: "Majhat",
    label: "Majhat",
  },
  {
    value: "Nabha",
    label: "Nabha",
  },
  {
    value: "Fagli",
    label: "Fagli",
  },
  {
    value: "Jakhu",
    label: "Jakhu",
  },
  {
    value: "Benmore",
    label: "Benmore",
  },
  {
    value: "Malyana",
    label: "Malyana",
  },
];
export const TehsilData = [
  {
    value: "Jawali",
    label: "Jawali",
  },
  {
    value: "Indora",
    label: "Indora",
  },
  {
    value: "Dehra",
    label: "Dehra",
  },
  {
    value: "Shahpur",
    label: "Shahpur",
  },
  {
    value: "Baroh",
    label: "Baroh",
  },
  {
    value: "Khundian",
    label: "Khundian",
  },
  {
    value: "Dadasiba",
    label: "Dadasiba",
  },
  {
    value: "Rakkar",
    label: "Rakkar",
  },
  {
    value: "Fatehpur",
    label: "Fatehpur",
  },
];

export const TypeOfLetter = [
  {
    value: "Approval",
    label: "Approval",
    name: "Approval",
  },
  {
    value: "Shortfall",
    label: "Shortfall",
    name: "Shortfall",
  },
  {
    value: "Rejected",
    label: "Rejected",
    name: "Rejected",
  },
];

export const proposalOptionsPlotted = [
  // {
  //   value: "Plot sub-division",
  //   label: "Plot sub-division",
  //   name: "Plot sub-division",
  // },
  {
    value: "Layout Development",
    label: "Layout Development",
    name: "Layout Development",
  },
  // {
  //   value: "Amalgamation",
  //   label: "Amalgamation",
  //   name: "Amalgamation",
  // },
];

export const proposalOptions = [
  {
    value: "Plot sub-division",
    label: "Plot sub-division",
    name: "Plot sub-division",
  },
  {
    value: "Building Permission",
    label: "Building Permission",
    name: "Building Permission",
  },
  {
    value: "Amalgamation",
    label: "Amalgamation",
    name: "Amalgamation",
  },
];

export const groupHousingOrMultiUnits = [
  {
    value: "Group Housing",
    label: "Group Housing",
    name: "Group Housing",
  },
  {
    value: "Multi Units",
    label: "Multi Units",
    name: "Multi Units",
  },
];
